export const meteorologyTypes = {
  SUN: 'Sol',
  CLOUDY: 'Nublado',
}
export const OWNER = 'Provape'
